// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3LhXv","containerItemsCenter":"Skeleton_containerItemsCenter__1ce-G"};